<template>
  <div class="appconfig-nav d-block d-lg-none mb-5" :class="{'customized-affiliate': !!affiliateCustomizations}">
    <nav>
      <ul class="d-flex justify-content-evenly align-items-center ps-0 my-0">
        <li class="flex-fill d-block border-rounded rounded-2 nav-li"
          v-for="(item, index) in navItems" :key="item.url"
            :class="{
            'nav-li--active': activeRoute === item.url,
            'nav-li--completed': isNavItemComplete(item) || isNavItemCompleteOptimistic(item),
            'ms-1': index > 0
          }"
        >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { useApplicationConfigStore } from '~/store/application-config'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';
import { storeToRefs } from 'pinia'

const { activeRoute, isNavItemComplete, isNavItemCompleteOptimistic } = useNavItem()
const appConfigStore = useApplicationConfigStore()
const { navItems } = storeToRefs(appConfigStore)
const { affiliateCustomizations } = storeToRefs(useAffiliateCustomizationStore())

</script>

<style lang="scss" scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customizations-sidenav';

.nav-li {
  height: 0px;
  padding: 2px;
  background: $neutral-400;
}

.nav-li--active {
  border: 1px solid $neutral-600;
}

.nav-li--completed {
  background: $lime-200;
}

.customized-affiliate {
  @include affiliateCustomizedSidenav();
}
</style>
